(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
(function(){
  var nav = document.querySelector('.p-content-tabs');
  if(!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  if(!links.length) return;

  var REVIEWS_ID = 'shopify-section-template--22315728273548__179161791761dc2499';
  // Hide a tab if its target section does not exist (== that block has no content).
  var visible = [];
  links.forEach(function(a){
    var id = a.getAttribute('href').slice(1);
    var sec = document.getElementById(id);
    if(sec){
      visible.push({ a: a, sec: sec, isReviews: id === REVIEWS_ID });
    } else {
      a.style.display = 'none';
    }
  });

  // If none of Description / Key features / Specifications / Product details exist,
  // there is nothing to tab between -> hide the whole bar (avoid a lone "Reviews" tab).
  var hasContent = visible.some(function(o){ return !o.isReviews; });
  if(!hasContent){ nav.style.display = 'none'; syncOffsets(); return; }

  // --- keep the sticky buy-box clear of the header + sticky tab bar ---------
  function syncOffsets(){
    var root = document.documentElement;
    function num(prop, dflt){
      var v = parseFloat(getComputedStyle(root).getPropertyValue(prop));
      return isNaN(v) ? dflt : v;
    }
    var headerH = num('--header-height', 0);
    var isSticky = num('--header-is-sticky', 1);
    var headerTop = isSticky ? headerH : 0;
    var tabsH = (nav && nav.offsetParent !== null) ? nav.offsetHeight : 0;
    root.style.setProperty('--p-tabs-top', Math.round(headerTop) + 'px');
    root.style.setProperty('--p-sticky-top', Math.round(headerTop + tabsH) + 'px');
  }
  syncOffsets();
  window.addEventListener('load', syncOffsets);
  window.addEventListener('resize', syncOffsets);
  if(window.ResizeObserver){ try { new ResizeObserver(syncOffsets).observe(nav); } catch(e){} }
  setTimeout(syncOffsets, 1200);

  function setActive(sec){
    visible.forEach(function(o){ o.a.classList.toggle('is-active', o.sec === sec); });
  }
  // initial active = first visible tab
  visible.forEach(function(o, i){ o.a.classList.toggle('is-active', i === 0); });

  links.forEach(function(a){
    a.addEventListener('click', function(e){
      var hash = a.getAttribute('href');
      var sec = document.getElementById(hash.slice(1));
      if(!sec) return;
      // Scroll ourselves so scroll-margin-top (header + sticky tab bar) is honoured;
      // the theme's own anchor handling lands the section under the header.
      e.preventDefault();
      e.stopPropagation();
      setActive(sec);
      // Keep the tapped tab visible: horizontally center it in the (scrollable) tab bar
      var tabsNav = a.closest('.p-content-tabs');
      if (tabsNav) {
        try { tabsNav.scrollTo({ left: a.offsetLeft - (tabsNav.clientWidth - a.offsetWidth) / 2, behavior: 'smooth' }); }
        catch (errTabs) { tabsNav.scrollLeft = a.offsetLeft - (tabsNav.clientWidth - a.offsetWidth) / 2; }
      }
      var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--p-sticky-top'));
      if(isNaN(off)) off = 0;
      var y = sec.getBoundingClientRect().top + window.pageYOffset - off - 16;
      try { window.scrollTo({ top: Math.max(0, y), behavior: 'smooth' }); }
      catch(err) { window.scrollTo(0, Math.max(0, y)); }
      if(window.history && window.history.replaceState){
        window.history.replaceState(null, '', hash);
      }
    });
  });
  if('IntersectionObserver' in window){
    var io = new IntersectionObserver(function(entries){
      var seen = entries.filter(function(e){ return e.isIntersecting; });
      if(seen.length){
        seen.sort(function(a,b){ return a.boundingClientRect.top - b.boundingClientRect.top; });
        setActive(seen[0].target);
      }
    }, { rootMargin: '-130px 0px -55% 0px', threshold: 0 });
    visible.forEach(function(o){ io.observe(o.sec); });
  }
})();
// ===== Mobile sticky add-to-cart / buy-now bar =====
(function(){
  var bar = document.getElementById('p-sticky-buy');
  if(!bar) return;
  var cartBtn = bar.querySelector('[data-p-sticky-buy]');
  var buyBtn  = bar.querySelector('[data-p-sticky-buy-now]');
  var priceEl = bar.querySelector('.p-sticky-buy__price');
  var mq = window.matchMedia('(max-width: 999px)');

  // Always resolve DOM freshly: the theme's <product-rerender> replaces the form
  // on variant change, so cached references would become detached nodes.
  function formEl(){
    if(!cartBtn) return null;
    return document.getElementById(cartBtn.getAttribute('data-p-sticky-buy'));
  }
  function buyBox(){ return document.querySelector('.product-form__buy-buttons'); }
  function addBtn(){ var f = formEl(); return f ? f.querySelector('.product-form__add-button') : null; }
  function stickyOffset(){
    var v = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--p-sticky-top'));
    return (isNaN(v) ? 111 : v) + 8;
  }

  function syncPrice(){
    var src = document.querySelector('.product-block-list__item--info .price-list .price');
    if(!src || !priceEl) return;
    var clone = src.cloneNode(true);
    var hidden = clone.querySelectorAll('.visually-hidden, .sr-only, [class*="visually-hidden"]');
    for(var i = 0; i < hidden.length; i++){ hidden[i].parentNode.removeChild(hidden[i]); }
    var txt = (clone.textContent || '').replace(/\s+/g, ' ').trim();
    if(txt) priceEl.textContent = txt;
  }

  function shouldShow(){
    if(!mq.matches) return false;                                   // desktop: never
    if(document.documentElement.classList.contains('is-locked')) return false; // cart drawer / modal open
    var add = addBtn();
    if(!add || add.disabled || !add.getClientRects().length) return false; // hidden / sold out
    // Track the add-to-cart button itself (the buy-buttons wrapper also contains
    // the payment-icon row, which is ~180px lower and would delay the bar too much).
    // Show as soon as the button is hidden behind the sticky header+tabs.
    return add.getBoundingClientRect().bottom < stickyOffset();
  }

  var ticking = false;
  function update(){
    if(ticking) return;
    ticking = true;
    var run = function(){
      ticking = false;
      var show = shouldShow();
      if(show) syncPrice();
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    if(window.requestAnimationFrame) { window.requestAnimationFrame(run); } else { run(); }
  }

  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  window.addEventListener('load', update);
  if(mq.addEventListener) { mq.addEventListener('change', update); } else if(mq.addListener) { mq.addListener(update); }
  // Variant changes re-render the form; theme also toggles html.is-locked for drawers.
  document.addEventListener('change', function(e){
    if(e.target && e.target.closest && e.target.closest('product-form')) {
      setTimeout(function(){ syncPrice(); update(); }, 80);
    }
  });
  if(window.MutationObserver){
    new MutationObserver(update).observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
  }
  update();

  // Add to cart: reuse the theme's own AJAX + cart drawer flow.
  if(cartBtn) cartBtn.addEventListener('click', function(){
    var add = addBtn();
    if(add) add.click();
  });

  // Buy now: add the currently selected variant then go straight to checkout.
  if(buyBtn) buyBtn.addEventListener('click', function(){
    var f = formEl();
    if(!f) return;
    var idEl = f.querySelector('input[name="id"]') || f.querySelector('input[name="id"]:checked');
    var qtyEl = f.querySelector('input[name="quantity"]');
    var vid = idEl ? idEl.value : null;
    if(!vid){ var add = addBtn(); if(add) add.click(); return; }
    var qty = parseInt(qtyEl && qtyEl.value, 10) || 1;
    var label = buyBtn.textContent;
    buyBtn.disabled = true;
    buyBtn.textContent = 'Processing...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(vid) || vid, quantity: qty }] })
    }).then(function(r){
      if(!r.ok) throw new Error('cart add failed');
      window.location.href = '/checkout';
    }).catch(function(){
      buyBtn.disabled = false;
      buyBtn.textContent = label;
      var add = addBtn();
      if(add) add.click();
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
